var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.showLayer
      ? _c("div", { staticClass: "layer" }, [
          _vm.currentLayer === 1
            ? _c("div", [
                _c("div", { staticClass: "layer1" }, [
                  _c("div", { staticClass: "layer1-title" }, [
                    _vm._v(_vm._s(_vm.$t("Sop.QuickEntryLayer.FirstLine")))
                  ]),
                  _c(
                    "div",
                    { staticClass: "layer-arrow-top" },
                    [
                      _c("svg-icon", {
                        staticClass: "arrow-common",
                        attrs: { "icon-class": "guide-arrow" }
                      })
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "layer2" }, [
                  _c("div", { staticClass: "layer-title-bottom" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("Sop.QuickEntryLayer.SecondLine")) +
                        " "
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "layer-arrow-bottom" },
                    [
                      _c("svg-icon", {
                        staticClass: "arrow-common",
                        attrs: { "icon-class": "guide-arrow" }
                      })
                    ],
                    1
                  )
                ]),
                _c("div", {
                  staticClass: "layer3",
                  style: { width: _vm.isOpen ? "207px" : "50px" }
                }),
                _c("div", { staticClass: "layer4" })
              ])
            : _vm._e(),
          _vm.currentLayer === 2
            ? _c("div", [
                _c("div", { staticClass: "second-layer1" }),
                _c("div", { staticClass: "second-layer2" }, [
                  _c(
                    "div",
                    { staticClass: "second-arrow" },
                    [
                      _c("svg-icon", {
                        staticClass: "arrow-common",
                        attrs: { "icon-class": "guide-arrow" }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "second-tip" }, [
                    _c("div", [
                      _vm._v(_vm._s(_vm.$t("Sop.SopBoardLayer.FirstLine2")))
                    ]),
                    _c("div", [
                      _vm._v(_vm._s(_vm.$t("Sop.SopBoardLayer.SecondLine2")))
                    ])
                  ])
                ]),
                _c("div", {
                  staticClass: "second-layer3",
                  style: { width: _vm.isOpen ? "207px" : "50px" }
                }),
                _c("div", { staticClass: "second-layer4" })
              ])
            : _vm._e(),
          _vm.currentLayer === 3
            ? _c("div", [
                _c("div", { staticClass: "three-layer1" }, [
                  _c("div", { staticClass: "three-tip" }, [
                    _c("div", [
                      _vm._v(_vm._s(_vm.$t("Sop.LineChartLayer.FirstLine")))
                    ]),
                    _c(
                      "div",
                      { staticClass: "three-arrow" },
                      [
                        _c("svg-icon", {
                          staticClass: "arrow-common",
                          attrs: { "icon-class": "guide-arrow" }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _c("div", { staticClass: "three-layer2" }),
                _c("div", {
                  staticClass: "three-layer3",
                  style: { width: _vm.isOpen ? "207px" : "50px" }
                }),
                _c("div", { staticClass: "three-layer4" })
              ])
            : _vm._e(),
          _c("div", [
            _c(
              "div",
              { staticClass: "next-step", on: { click: _vm.nextStep } },
              [_vm._v(_vm._s(_vm.$t("Sop.NextStep")))]
            ),
            _c("div", { staticClass: "circle-wrapper" }, [
              _c("span", {
                class: { active: _vm.currentLayer === 1 },
                on: {
                  click: function($event) {
                    return _vm.showCurrentLayer(1)
                  }
                }
              }),
              _c("span", {
                class: { active: _vm.currentLayer === 2 },
                on: {
                  click: function($event) {
                    return _vm.showCurrentLayer(2)
                  }
                }
              }),
              _c("span", {
                class: { active: _vm.currentLayer === 3 },
                on: {
                  click: function($event) {
                    return _vm.showCurrentLayer(3)
                  }
                }
              })
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }